// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__Gu+9I","checkmark":"CheckBox_checkmark__5uOgh"};